import { Box, Button } from '@mui/material';
import { t } from 'i18next';

const TaskListActionBar = ({
  collapseAllCategories,
  allCategoriesAreUncollapsed
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      marginTop={1.5}
      marginBottom={1.75}
    >
      <Button onClick={collapseAllCategories} variant="text">
        {t(
          `taskList.${
            allCategoriesAreUncollapsed ? 'collapseAll' : 'uncollapseAll'
          }`
        )}
      </Button>

      {/*
      // TODO - Enable when filter functionality is ready
      <ListItemIcon sx={{ display: 'contents' }}>
        <Icon type="sliders" fontSize="small" />
      </ListItemIcon> */}
    </Box>
  );
};

export default TaskListActionBar;
